import { Check } from "lucide-react";
import type { Question } from "./types";

type Props = {
  question: Question;
  value?: number;
  onChange: (value: number) => void;
  index: number;
  disabled?: boolean;
};

export const QuestionCard = ({ question, value, onChange, index, disabled = false }: Props) => {
  return (
    <fieldset className="space-y-3">
      <legend className="flex items-baseline gap-3">
        <span className="text-xs font-semibold tracking-wider text-primary">
          Q{String(index).padStart(2, "0")}
        </span>
        <span className="text-base font-medium text-foreground">
          {question.label}
        </span>
      </legend>

      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
        {question.options.map((opt) => {
          const selected = value === opt.value;
          return (
            <label
              key={opt.value}
              className={[
                "group relative flex cursor-pointer items-center gap-3 rounded-xl border bg-card px-4 py-3 transition-all",
                "hover:-translate-y-0.5 hover:shadow-[var(--shadow-card-hover)]",
                selected
                  ? "border-primary bg-[hsl(var(--primary-soft))] ring-1 ring-primary"
                  : "border-border",
              ].join(" ")}
            >
              <input
                type="radio"
                name={question.id}
                value={opt.value}
                checked={selected}
                disabled={disabled}
                onChange={() => onChange(opt.value)}
                className="sr-only"
              />
              <span
                aria-hidden
                className={[
                  "flex h-5 w-5 flex-none items-center justify-center rounded-full border transition-colors",
                  selected
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-muted-foreground/30 bg-background",
                ].join(" ")}
              >
                {selected && <Check className="h-3 w-3" strokeWidth={3} />}
              </span>
              <span className="text-sm font-medium text-foreground">
                {opt.label}
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
};
